import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex justify-between h-16" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "-ml-2 mr-2 flex items-center md:hidden" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 flex items-center" }, null, -1)
const _hoisted_7 = { class: "hidden md:ml-6 md:flex md:items-center md:space-x-4" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = {
  type: "button",
  class: "hidden relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Contact Me", -1)
const _hoisted_12 = { class: "hidden md:ml-4 md:flex-shrink-0 md:flex md:items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_14 = { class: "h-8 w-8 rounded-full grid place-items-center" }
const _hoisted_15 = { class: "text-white text-centered" }
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" }
const _hoisted_18 = {
  key: 0,
  class: "pt-4 pb-3 border-t border-gray-700"
}
const _hoisted_19 = { class: "flex items-center px-5 sm:px-6" }
const _hoisted_20 = { class: "ml-3" }
const _hoisted_21 = { class: "text-base font-medium text-white" }
const _hoisted_22 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_23 = { class: "mt-3 px-2 space-y-1 sm:px-3" }
const _hoisted_24 = {
  key: 1,
  class: "pt-4 pb-3 border-t border-gray-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_WNavButton = _resolveComponent("WNavButton")!
  const _component_WNavDropdown = _resolveComponent("WNavDropdown")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Disclosure, {
      as: "nav",
      class: "bg-gray-800 w-screen opacity-100 z-10"
    }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_DisclosureButton, { class: "inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    (!open)
                      ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                          key: 0,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                      : (_openBlock(), _createBlock(_component_XMarkIcon, {
                          key: 1,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.name
                  }, [
                    (!item.lgHidden)
                      ? (_openBlock(), _createBlock(_component_WNavButton, {
                          key: 0,
                          title: item.name,
                          href: item.href
                        }, null, 8, ["title", "href"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_ctx.AuthState.isAuthenticated && !_ctx.AuthState.loading && _ctx.user.email.includes('\@targa.partners'))
                  ? (_openBlock(), _createBlock(_component_WNavButton, {
                      key: 0,
                      title: "Targa",
                      href: "/targa"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_WNavDropdown, {
                  title: _ctx.projectsDropDown.title,
                  navs: _ctx.projectsDropDown.navs
                }, null, 8, ["title", "navs"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", _hoisted_10, [
                  _createVNode(_component_PlusIcon, {
                    class: "-ml-1 mr-2 h-5 w-5",
                    "aria-hidden": "true"
                  }),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Menu, {
                  as: "div",
                  class: "ml-3 relative"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_ctx.AuthState.isAuthenticated && !_ctx.AuthState.loading)
                        ? (_openBlock(), _createBlock(_component_MenuButton, {
                            key: 0,
                            class: "bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13,
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.initials), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.AuthState.isAuthenticated)
                        ? (_openBlock(), _createBlock(_component_WNavButton, {
                            key: 1,
                            title: 'Sign In',
                            href: '',
                            onClick: _ctx.login
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-200",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItems, { class: "z-10 origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                              return (_openBlock(), _createBlock(_component_MenuItem, {
                                key: item.name
                              }, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("a", {
                                    href: item.href,
                                    onClick: item.action,
                                    class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'])
                                  }, _toDisplayString(item.name), 11, _hoisted_16)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createVNode(_component_DisclosurePanel, { class: "md:hidden" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                return (_openBlock(), _createBlock(_component_DisclosureButton, {
                  key: item.name,
                  as: "a",
                  href: item.href,
                  class: _normalizeClass([item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'block px-3 py-2 rounded-md text-base font-medium']),
                  "aria-current": item.current ? 'page' : undefined
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["href", "class", "aria-current"]))
              }), 128))
            ]),
            (_ctx.AuthState.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.user.given_name), 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.user.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                      return (_openBlock(), _createBlock(_component_DisclosureButton, {
                        key: item.name,
                        as: "a",
                        href: item.href,
                        onClick: item.action,
                        class: "block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["href", "onClick"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.AuthState.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_DisclosureButton, {
                    class: "block px-3 py-2 rounded-md text-base font-medium text-white hover:text-white hover:bg-gray-700",
                    onClick: _ctx.login
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Sign In")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ], 64))
}